<template>
  <div id="demo-basic-card">
    <!-- frase de explicação
        <div class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-center">
            <h1 class="">Adicionar novo dispositivo para monitorar:</h1>
            <p class="">Você pode monitorar dispositivos <strong>Android</strong> ou Computadores <strong>Windows</strong>. Baixe a programa de instalação correspondente ao dispositivo que você deseja monitorar.
                        Em seguida, siga as instruções <strong>"Como instalar".</strong> O acesso físico ao dispositivo é necessário.</p>
    </div><br>-->
    <div class="vx-row">
      <!-- celular -->
      <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base" v-if="appName.indexOf('wSpy') > -1 || appName.indexOf('spyou') > -1">
        <vx-card>
          <div class="my-6 text-center">
            <i class="fas fa-mobile-alt fa-4x text-primary"></i>
            <br />
            <br />
            <h5 class="mb-2"> {{$t("MonitorAndroid")}} </h5>
            <p class="text-grey">
              {{$t("MonitorAndroidTwo")}}
            </p>
            <br />
            <a :href="`${appDownloadMobile}`">
              <button name="button" class="vs-component vs-button vs-button-warning vs-button-relief">
                <span class="vs-button-text vs-button--text"> <i class="fab fa-android"></i> {{$t("DownloadNow")}} </span>
                <span
                  class="vs-button-linex"
                  style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"
                ></span>
              </button>
            </a>
            <br />
            <br />
            <p class="text-grey"> {{$t("DownloadNow")}} {{$t("MonitorAndroidThree")}} </p>
            <br />
            <a :href="`${appDownloadMobileBit}`" target="_blank" ><span class="label label-lg p-4"> <i class="fa fa-globe"></i> Ver Video</span> </a>
          </div>
          <vs-divider></vs-divider>
          <div class="flex justify-between flex-wrap">
            <span>
              <a :href="`https://api.whatsapp.com/send?phone=${appWhatsAppMobileNumber}`">
                <p class="text-xl"><i class="fab fa-whatsapp"></i> {{$t("ContactUs")}} </p>
                <p class="text-grey">WhatsApp</p>
              </a>
            </span>
            <span>
              <a :href="`${appSuporteManual}`" target="_blank">
                <p class="text-xl"> {{$t("Guide")}} </p>
                <p class="text-grey">{{$t("ClickHere")}}</p>
              </a>
            </span>
          </div>
        </vx-card>
      </div>
      <!-- computador -->
      <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base" v-if="appName.indexOf('wSpy') > -1 || appName.indexOf('Wee') > -1">
        <vx-card>
          <div class="my-6 text-center">
            <i class="fab fa-windows fa-4x text-primary"></i>
            <br />
            <br />
            <h5 class="mb-2">{{$t("MonitorComputer")}}</h5>
            <p class="text-grey">
              {{$t("MonitorAndroidTwo")}}
            </p>
            <br />
            <a href="https://wtsoftware.com.br/download-exe.html">
              <button name="button" class="vs-component vs-button vs-button-warning vs-button-relief">
                <span class="vs-button-text vs-button--text"> <i class="fab fa-windows"></i> {{$t("DownloadNow")}} </span>
                <span
                  class="vs-button-linex"
                  style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"
                ></span>
              </button>
            </a>
            <br />
            <br />
            <p class="text-grey"> {{$t("RegisterLicense")}} </p>
            <br />
            <button type="button" class="label label-lg p-4" @click="$router.push('/desktop-adicionar-licenca')">
              <i class="fab fa-windows"></i> {{$t("ClickHere")}}
            </button>
          </div>
          <vs-divider></vs-divider>
          <div class="flex justify-between flex-wrap">
            <span>
              <a :href="`https://api.whatsapp.com/send?phone=${appWhatsAppMobileNumber}`">
                <p class="text-xl"><i class="fab fa-whatsapp"></i> {{$t("ContactUs")}}</p>
                <p class="text-grey">WhatsApp</p>
              </a>
            </span>
            <span>
              <a href="http://suporte.wtsoftware.com.br/help-center/categories/4/portugu-s" target="_blank">
                <p class="text-xl"> {{$t("Guide")}} </p>
                <p class="text-grey">{{$t("ClickHere")}}</p>
              </a>
            </span>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      appWhatsAppMobileNumber: process.env.VUE_APP_TELEFONE_NAO_FORMATADO_WHATSAPP,
      appDownloadMobile: process.env.VUE_APP_DOWNLOAD_MOBILE,
      appName: process.env.VUE_APP_NAME,
      appDownloadMobileBit: process.env.VUE_APP_DOWNLOAD_MOBILE_BIT,
      appSuporteManual: process.env.VUE_APP_SUPORTE_MANUAL
    };
  },
};
</script>

<style lang="scss">
#demo-basic-card {
  .overlay-card {
    .vx-card__collapsible-content {
      max-height: 485px;
    }
  }

  .chat-card-log {
    height: 360px;

    .chat-sent-msg {
      background-color: #f2f4f7 !important;
    }
  }

  .card-video {
    .video-js {
      height: 370px;
    }
  }
  .label-lg {
    font-size: 1.33rem !important;
    padding: 5px 9px;
  }
  .label {
    display: inline-block;
    padding: 0.25em 0.5em;
    font-size: 75%;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    font-weight: 700;
    background-color: #b8b8b8;
    color: #fff;
    border-radius: 0.2rem;
  }
}
</style>
